import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { getBestOfArticlesIndexPath } from 'site-modules/editorial/utils/content-path';
import { Best } from 'site-modules/editorial/pages/best/best';

function TwoColumnBestUI({ content = null, slug }) {
  if (!content) {
    return null;
  }

  return <Best content={content} category={slug} hasLinkWidget />;
}

TwoColumnBestUI.propTypes = {
  slug: PropTypes.string.isRequired,
  content: CmsEntities.Content,
};

export const TwoColumnBest = connectToModel(TwoColumnBestUI, {
  content: bindToContent(({ slug, articleId }) => getBestOfArticlesIndexPath(slug, articleId)),
});
